export default __webpack_public_path__ + "static/media/plus.04a1e354.svg";